import { CommentAndButtonComponent } from './CommentAndButtonComponent';
import { tag } from '../../utils/tag';

export class ResultComponent extends CommentAndButtonComponent {
    #data;

    constructor(data, buttonLabel, actionEvent) {
        super(data.text, buttonLabel, actionEvent);

        this.#data = data;
    }

    _render(parentNode) {
        const rootEl = tag('section', 'result');
        const titleEl = tag('h2', 'h2', this.#data.title);

        rootEl.appendChild(titleEl);

        // Append a text block and a button
        super._render(rootEl);

        parentNode.appendChild(rootEl);

        return [rootEl];
    }

    get data() {
        return this.#data;
    }

    set data(value) {
        this.#data = value;
        this.text = value.text;
    }
}
